// https://imagelink.click/duVV.txt   => 8/10/25
// https://imagelink.click/zTfZ.txt   => 21/11/25
// https://imagelink.click/uIUA.txt   => 04/03/26


setTimeout(function(){
  


//  =============== product cstm_prixxx calculation ============= 
  function calx(){
    
     if(current_product.title  == 'PUBGOLF' ){ 
    
      $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)

        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €9,95 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,49)')
          
          var calculationx = parseFloat(totlxx + 7.46).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          
        // Price Static Change
         $('.custm_prix').html('€12,95 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,99)')

          var calculationx = parseFloat(totlxx + 9.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
          
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')

// apply custom caluclation if product tag is equanl to 'custom_calculation'
  }else if(current_product.tags.indexOf('custom_calculation')>-1){ 

  $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)
    
        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €11,95 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,49)')
          var calculationx = parseFloat(totlxx + 9.46).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          // Price Static Change
         $('.custm_prix').html('€14,95 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,99)')
          var calculationx = parseFloat(totlxx + 11.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')


 }else if(current_product.tags.indexOf('new_custom_calculation_1')>-1){ 

  $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)
    
        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €20,95 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,49)')
          var calculationx = parseFloat(totlxx + 18.46).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          // Price Static Change
         $('.custm_prix').html('€23,95 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,99)')
          var calculationx = parseFloat(totlxx + 20.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')


 }else if(current_product.tags.indexOf('new_custom_calculation_2')>-1){ 

  $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)
    
        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €18,95 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,49)')
          var calculationx = parseFloat(totlxx + 16.46).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          // Price Static Change
         $('.custm_prix').html('€21,95 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,99)')
          var calculationx = parseFloat(totlxx + 18.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')

 }else if(current_product.tags.indexOf('new_custom_calculation_3')>-1){ 

  $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)
    
        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €17,95 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,49)')
          var calculationx = parseFloat(totlxx + 15.46).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          // Price Static Change
         $('.custm_prix').html('€20,95 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART 1 PER PERSOON (+€2,99)')
          var calculationx = parseFloat(totlxx + 17.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')

 }else if(current_product.tags.indexOf('custom-note-shirt')>-1){ 

  $('.fnlx').remove()
  
      var qntx = $('[name="quantity"]').val()
      // console.log('Quantity',qntx)
      
      var prix = parseFloat($('span.price-item.price-item--regular').text().replace(',','').split('EUR')[0].trim().split('€')[1])
      // console.log('Price',prix)
  
      var totlxx = parseFloat((qntx*prix)/100)
      // console.log('totl Price',totlxx)
    
        if($('.select__select').find('option:selected').val()  == '9 HOLES'){
          // Price Static Change
          $('.custm_prix').html(' €53,90 EUR')
          // Quanity label change
          $('.custm_lbl').text('SCORE KAART + MYSTERY SHIRT 1 PER PERSOON (+€44,44)')
          var calculationx = parseFloat(totlxx + 9.46).toFixed(2).replace('.',',')
          // console.log('9 HOLES - Price',calculationx)
        
        }else if($('.select__select').find('option:selected').val()  == '18 HOLES'){
          // Price Static Change
         $('.custm_prix').html('€56,90 EUR')
         // Quanity label change
          $('.custm_lbl').text('SCORE KAART + MYSTERY SHIRT 1 PER PERSOON (+€44,94)')
          var calculationx = parseFloat(totlxx + 11.96).toFixed(2).replace('.',',')
          // console.log('18 HOLES - Price',calculationx)
        }
    
    $('[class="quantity"]').after('<div class="fnlx" style="font-size: large; margin-top: 20px;">Subtotal (' +qntx+ ' items): €' +calculationx+' EUR<div>')

  }


  }
    


  // =========== on load =============
  
      setTimeout(function(){
        calx()
      },500)
  
  // ========== VAR CHANGE ============
  
    $(document).on('change','select.select__select',function(){
     setTimeout(function(){
        calx()
      },1000)
    })
  
        
  // ========== Qnty CHANGE ============
  
  $('quantity-input.quantity').change(function(){
      calx(500)
  })


  

// ================================= Qty slectr remove from Cart for specific products  =================================


function qty_box(){
  $('.cart-item').each(function(){
    var  _thix = $(this);
    var prod_tagx =  _thix.find('.cart-item__name').attr('tagxxx')
    // console.log('Product-Tagx ',prod_tagx)
      if(prod_tagx == 'qty_box'){
        _thix.find('.quantity-popover-container').attr('style','display:none;')
      }
  })
}



// ================================= Cart Calculation  =================================

function cart_calx(){

  $('.cart-item').each(function(){
  var  _this = $(this);

  var subtotal = parseFloat($('.totals__total-value').text().replace(',','').split('€')[1].split('EUR')[0]);
  var subtotal = subtotal/100;
  //  console.log('reg-subtotal',subtotal)
  
  var prod_varx  =  _this.find('.cart-item__name').attr('href');
   // console.log('Product-Variant ',prod_varx)

  var prodx =  _this.find('.cart-item__name').attr('href').split('?variant')[0];

  // check cart product tag 
  var tagsx =  _this.find('.cart-item__name').attr('tagxxx')

  // console.log('Product_tag',tagsx)
  // console.log('Product',prodx)

  var  var_titlx =   _this.find('.cart-item__details .product-option:nth-child(1) dd.varx_titlxx').text().trim()
  // console.log('Varinat-Title',var_titlx)

// ================================ PRODUCT :: pubgolf-classic ================================


  if(prod_varx == '/products/pubgolf-classic?variant=49853964353869'){
      // console.log('9 HOLES - Pubgolf')
      
  _this.find('.cstm_prixxx').text('€9,95')
   
  var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
  var prixxx = prixxx/100
      // console.log('reg-item-total-prix',prixxx)

  
  var totxx = (prixxx+7.46).toFixed(2).replace('.',',')
      // console.log('final-item-total-prix',totxx)
  
  _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
  
  var finalxxx = (subtotal+7.46).toFixed(2).replace('.',',')
      // console.log('final-subtotal',finalxxx)
  
  $('.totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
  
      
  }else if(prod_varx == '/products/pubgolf-classic?variant=49853964386637'){
  
     // console.log('18 HOLES - pubgolf')
  
  _this.find('.cstm_prixxx').text('€12,95')
   
  var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
  var prixxx = prixxx/100
      // console.log('reg-item-total-prix',prixxx)

  
  var totxx = (prixxx+9.96).toFixed(2).replace('.',',')
      // console.log('final-item-total-prix',totxx)
  
  _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
  
  
  var finalxxx = (subtotal+9.96).toFixed(2).replace('.',',')
      // console.log('final-subtotal',finalxxx)
  
  $('.totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
  


// ================================ PRODUCT :: custom_calculation tag ================================

// }else if(prodx == '/products/pubgolf-stedentrip-editie' || prodx == '/products/pubgolf-classic-stad-route' || prodx == '/products/pubgolf-zuipvakantie-editie' || prodx == '/products/pubgolf-breda' || prodx == '/products/pubgolf-maastricht' || prodx == '/products/pubgolf-zwolle' || prodx == '/products/pubgolf-gent' || prodx == '/products/pubgolf-nijmegen' || prodx == '/products/pubgolf-antwerpen' || prodx == '/products/pubgolf-utrecht' || prodx == '/products/pubgolf-amsterdam' || prodx == '/products/pubgolf-eindhoven' || prodx == '/products/pubgolf-groningen'){
 
// check condition cart product tag 
}else if(tagsx == 'custom_calculation'){
 
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      // console.log('9 HOLES - custom_calculation tag')

      _this.find('.cstm_prixxx').text('€11,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+9.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+9.46).toFixed(2).replace('.',',')
          // console.log('final-subtotal',finalxxx)
      
      $('.totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      // console.log('18 HOLES - pubgolf-classic-stad-route')

      _this.find('.cstm_prixxx').text('€14,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+11.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+11.96).toFixed(2).replace('.',',')
          // console.log('final-subtotal',finalxxx)
      
      $('.totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }
    
// ================================ PRODUCT :: Shipping removed ================================



  }else if(prod_varx == '/products/shipping?variant=50440307114317'){
      console.log('Produc:: Shipping')
    //    _this.remove()
  }


})
  
}


// =========== on load =============

 setTimeout(function(){
    qty_box()
 },50)


  setTimeout(function(){
    // cart_calx()
    qty_box()
  },1000)


// =========== Qty Change =============
  
$(document).on('change','input.quantity__input',function(){
  setTimeout(function(){
    qty_box()
  },2500)
})


$(document).on('click','a.button.button--tertiary,.cart-remove-button,button.quantity__button',function(){
  setTimeout(function(){
    qty_box()
  },2500)
})


  




// ================= Redirect to locaties page when click on locaties in header menue ===================
    $('summary#HeaderMenu-locaties span').click(function(){
        window.location.href = '/pages/locaties'
    })

      $('.limkxx').click(function(){
        // console.log('kokok')
        window.location.href = '/pages/locaties'
    })
  
// ======================= Custom product static price and link chnage =========================

    $('.grid__item').each(function(){
      var _thiss = $(this)
      var handle = _thiss.find('.full-unstyled-link').attr('href')
          console.log('handle',handle)    

if(handle == '/products/pubgolf-route-online' ){
 _thiss.find('.price').text('VANAF €14,95 EUR')
  
}else if(handle == '/products/pubgolf-online'){

}
if(handle  == '/products/pubgolf-custom'){
          _thiss.find('.price').text('OP AANVRAAG')
          _thiss.find('.full-unstyled-link').attr('href','/pages/contact')
        }else if(handle  == "/products/pubgolf-classic"){
            _thiss.find('.prod_prixxx').text('€9,95 EUR')
         }else if(handle  == "/products/pubgolf-zuipvakantie-editie"){
            _thiss.find('.prod_prixxx').text('€11,95 EUR')
        }else if(handle  == "/products/pubgolf-classic-stad-route"){
            _thiss.find('.prod_prixxx').text('€11,95 EUR')
        }else if(handle == '/products/pubgolf-tilburg' || handle == '/products/pubgolf-rotterdam' || handle == '/products/pubgolf-den-haag' || handle == '/products/pubgolf-leuven' || handle == '/products/pubgolf-brugge' || handle == '/products/pubgolf-stedentrip-editie' || handle  == "/products/pubgolf-groningen" || handle  == "/products/pubgolf-eindhoven" || handle  == "/products/pubgolf-breda" || handle =="/products/pubgolf-maastricht" || handle == "/products/pubgolf-antwerpen" || handle == "/products/pubgolf-gent" || handle == "/products/pubgolf-utrecht" || handle == "/products/pubgolf-amsterdam" || handle == "/products/pubgolf-zwolle" || handle == "/products/pubgolf-nijmegen"){
            _thiss.find('.prod_prixxx').text('€11,95 EUR')
        }else if(handle  == "/products/extreme-editie-stad-route"){
          _thiss.find('.prod_prixxx').text('€20,95 EUR')  
        }else if(handle  == "/products/pubgolf-bijtende-krokodil-editie"){
        _thiss.find('.prod_prixxx').text('€17,95 EUR')  
        }else if(handle  == "/products/extreme-editie-in-eigen-stad"){
        _thiss.find('.prod_prixxx').text('€18,95 EUR')  
        }else if(handle  == "/products/shipping"){
            _thiss.remove()
        }
    })



// ========================= pubgolf image change from mobile =============================

if(window.location.href == 'https://72ff9e-b9.myshopify.com/pages/wat-is-pubgolf'){
  if($(window).width() < 767){
      $('.multirow__inner .image-with-text:nth-of-type(1) img').attr('srcset','https://cdn.shopify.com/s/files/1/0833/2617/3517/files/ppp.png?v=1723052003')  
      $('.multirow__inner .image-with-text:nth-of-type(2) img').attr('srcset','https://cdn.shopify.com/s/files/1/0833/2617/3517/files/pubgolf_kroegentocht.png?v=1723621149')
      $('.multirow__inner .image-with-text:nth-of-type(3) img').attr('srcset','https://cdn.shopify.com/s/files/1/0833/2617/3517/files/wat_is_pubgolf_nederland.png?v=1723621149')
    }
}


},500)




  // =============================== drawer opn =========================

    var draweload=false;
      var _intv = setInterval(function(){
        if($('.drawer.animate.active').length>0 && draweload==false){
          draweload=true;
          console.log("yessssssssssssss")


// ============== product banner label hide from drawer ===========

if($(window).width() < 767){}
  $('.aco-box.animate__none').hide()


// =============== upsell products ===================




setTimeout(function(){




  function drawer_popup(){


        $('.drawer__inner .popxx').remove()
            
              $('[href="/products/mystery-gift"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx" style="display: flex;"> <span class="popup" onclick="myFunction()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF WINERS PAKKET, MYSTERY PRIZE</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p> Bij Elke Competitie Hoort Een Winaar, En Een Winnaar Verdient Natuurlijk Een Prijs! Deze Mystery Gift Met Twee Toffe Prijzen Maakt De Strijd Nog Spannender. Het Is De Ultieme Beloning Voor Jouw Overwinning. Wat Erin Zit? Dat Blijft Een Verrassing… Tot Je Wint!</p> </span> </span> </div>')
              $('[href="/products/visor"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx BLAUW" style="display: flexxxxx;"> <span class="popup BLAUW" onclick="myFunctionBLAUW()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup BLAUW"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP BLAUW</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
              $('[href="/products/geel"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx GEEL" style="display: flexxxxx;"> <span class="popup GEEL" onclick="myFunctionGEEL()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup GEEL"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP GEEL</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
              $('[href="/products/groen"]').parents('[data-essential-upsell-element="content-container"]').after('<div class="boxx GROEN" style="display: flexxxxx;"> <span class="popup GROEN" onclick="myFunctionGROEN()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup GROEN"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP GROEN</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
              $('[href="/products/paars"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx PAARS" style="display: flexxxxx;"> <span class="popup PAARS" onclick="myFunctionPAARS()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup PAARS"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP PAARS</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
              $('[href="/products/rood"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx ROOD" style="display: flexxxxx;"> <span class="popup ROOD" onclick="myFunctionROOD()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup ROOD"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP ROOD</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')

              // href links remove from essential imgs    
              // $('cart-items [data-essential-upsell-element="title"],cart-items [data-essential-upsell-element="image-container"],.drawer__inner [data-essential-upsell-element="title"],.drawer__inner [data-essential-upsell-element="image-container"]').removeAttr('href')

        }




  

  function drawer_cart_calx(){

  $('.cart-item').each(function(){
  var  _this = $(this);

  var subtotal = parseFloat($('.drawer__footer .totals__total-value').text().replace(',','').split('€')[1].split('EUR')[0]);
  var subtotal = subtotal/100;
  //  console.log('reg-subtotal',subtotal)
  
  var prod_varx  =  _this.find('.cart-item__name').attr('href');
   // console.log('Product-Variant ',prod_varx)

  var prodx =  _this.find('.cart-item__name').attr('href').split('?variant')[0];

  // check cart product tag 
  var tagsx =  _this.find('.cart-item__name').attr('tagxxx')

  // console.log('Product_tag',tagsx)
  // console.log('Product',prodx)

  // var  var_titlx =   _this.find('.cart-item__details .product-option:nth-child(1) dd.varx_titlxx').text().trim()
    var  var_titlx =   _this.find('.cart-item__details .product-option:nth-child(1) dd.varx_titlxx').text().split(',')[0].trim()

  // console.log('Varinat-Title',var_titlx)

// ================================ PRODUCT :: pubgolf-classic ================================


  if(prod_varx == '/products/pubgolf-classic?variant=49853964353869'){
      // console.log('9 HOLES - Pubgolf')
      
  _this.find('.cstm_prixxx').text('€9,95')
   
  var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
  var prixxx = prixxx/100
      // console.log('reg-item-total-prix',prixxx)

  
  var totxx = (prixxx+7.46).toFixed(2).replace('.',',')
      // console.log('final-item-total-prix',totxx)
  
  _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
  
  var finalxxx = (subtotal+7.46).toFixed(2).replace('.',',')
      // console.log('final-subtotal',finalxxx)
  
  $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
  
      
  }else if(prod_varx == '/products/pubgolf-classic?variant=49853964386637'){
  
     // console.log('18 HOLES - pubgolf')
  
  _this.find('.cstm_prixxx').text('€12,95')
   
  var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
  var prixxx = prixxx/100
      // console.log('reg-item-total-prix',prixxx)

  
  var totxx = (prixxx+9.96).toFixed(2).replace('.',',')
      // console.log('final-item-total-prix',totxx)
  
  _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
  
  
  var finalxxx = (subtotal+9.96).toFixed(2).replace('.',',')
      // console.log('final-subtotal',finalxxx)
  
  $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
  


// ================================ PRODUCT :: custom_calculation tag ================================

// }else if(prodx == '/products/pubgolf-stedentrip-editie' || prodx == '/products/pubgolf-classic-stad-route' || prodx == '/products/pubgolf-zuipvakantie-editie' || prodx == '/products/pubgolf-breda' || prodx == '/products/pubgolf-maastricht' || prodx == '/products/pubgolf-zwolle' || prodx == '/products/pubgolf-gent' || prodx == '/products/pubgolf-nijmegen' || prodx == '/products/pubgolf-antwerpen' || prodx == '/products/pubgolf-utrecht' || prodx == '/products/pubgolf-amsterdam' || prodx == '/products/pubgolf-eindhoven' || prodx == '/products/pubgolf-groningen'){
 
// check condition cart product tag 
}else if(tagsx == 'custom_calculation'){
$('.cstms').remove()
  // _this.find('.product-option:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      console.log('9 HOLES - custom_calculation tag')

      _this.find('.cstm_prixxx').text('€11,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+9.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+9.46).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      console.log('18 HOLES - custom_calculation tag')

      _this.find('.cstm_prixxx').text('€14,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+11.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+11.96).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }

}else if(tagsx == 'new_custom_calculation_1'){
$('.cstms').remove()
  // _this.find('.product-option:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      console.log('9 HOLES - custom_calculation tag-1')

      _this.find('.cstm_prixxx').text('€20,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+18.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+18.46).toFixed(2).replace('.',',')
          // console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      // console.log('18 HOLES -  custom_calculation tag-2')

      _this.find('.cstm_prixxx').text('€23,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+20.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+20.96).toFixed(2).replace('.',',')
          // console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }


}else if(tagsx == 'new_custom_calculation_2'){

$('.cstms').remove()
  // _this.find('.product-option:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      console.log('9 HOLES - custom_calculation tag-2')

      _this.find('.cstm_prixxx').text('€18,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+16.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+16.46).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      // console.log('18 HOLES -  custom_calculation tag-2')

      _this.find('.cstm_prixxx').text('€21,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+18.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+18.96).toFixed(2).replace('.',',')
          // console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }


}else if(tagsx == 'new_custom_calculation_3'){

$('.cstms').remove()
  // _this.find('.product-option:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      // console.log('9 HOLES - custom_calculation tag-3')

      _this.find('.cstm_prixxx').text('€17,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+15.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+15.46).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      // console.log('18 HOLES -  custom_calculation tag-3')

      _this.find('.cstm_prixxx').text('€20,95')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+17.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+17.96).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }

    

    
// ================================Custom not attribut products ================================


}else if(tagsx == 'custom-note-shirt'){

$('.cstms').remove()
  // _this.find('.product-option:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
  // console.log('Product with custom_calculation tag')
    
  if(var_titlx == '9 HOLES'){
      // console.log('9 HOLES - custom_calculation tag-3')

      _this.find('.cstm_prixxx').text('€53,90')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+9.46).toFixed(2).replace('.',',')
     	  // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+9.46).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')
      

  }else if(var_titlx == '18 HOLES'){
      // console.log('18 HOLES -  custom_calculation tag-3')

      _this.find('.cstm_prixxx').text('€56,90')

      var prixxx = parseFloat(_this.find('span.price.price--end').text().replace(',','').split('€')[1]);
      var prixxx = prixxx/100
	 // console.log('reg-item-total-prix',prixxx)
      
      var totxx = (prixxx+11.96).toFixed(2).replace('.',',')
          // console.log('final-item-total-prix',totxx)
      
      _this.find('span.price.price--end').html('<span> €'+totxx+'</span>')
      
      var finalxxx = (subtotal+11.96).toFixed(2).replace('.',',')
          console.log('final-subtotal',finalxxx)
      
      $('.drawer__footer .totals__total-value').html('<span> €'+finalxxx+'  EUR</span>')

    }







// ================================ PRODUCT :: Shipping removed ================================



  }else if(prod_varx == '/products/shipping?variant=50440307114317'){
      console.log('Produc:: Shipping')
    //    _this.remove()
  }


})
  }

setTimeout(function(){
  drawer_cart_calx()
},1500)

setTimeout(function(){

 drawer_popup()
},3500)

    
$(document).on('change','input.quantity__input',function(){
  setTimeout(function(){
    // qty_box()
     drawer_popup()
    drawer_cart_calx()
  },2500)
})

$(document).on('click','.cart-remove-button,[data-essential-upsell-element="button-container"]',function(){
  setTimeout(function(){
    // qty_box()
     drawer_popup()
    drawer_cart_calx()
  },2500)
})


  


function qty_box(){
  // $('.cart-item').each(function(){
  //   var  _thix = $(this);
  //   var prod_tagx =  _thix.find('.cart-item__name').attr('tagxxx')
  //   // console.log('Product-Tagx ',prod_tagx)
  //     if(prod_tagx == 'qty_box'){
  //       _thix.find('.quantity-popover-container').attr('style','display:none;')

  //       _thix.find('cart-remove-button .button').attr('style','margin-left: -25px;')

  //     }
  // })


  $('.cart-item').each(function(e,index){
    var  _thix = $(this);
    var prod_tagx =  _thix.find('.cart-item__name').attr('tagxxx')
    console.log('Product-Tagx ',e,prod_tagx)
      if(prod_tagx == 'qty_box'){
        _thix.find('.quantity-popover-container').attr('style','display:none;')
        _thix.find('cart-remove-button .button').attr('style','margin-left: -25px;')
      } else if(prod_tagx == 'custom_calculation'){
         _thix.find('.optxx:last').after('<span class="cstms" style="font-size: small;"> AANTAL PERSONEN</span>')
      }
  })


}

  setTimeout(function(){
    qty_box()
     drawer_popup()
    // drawer_cart_calx()
  },1500)




        
},1500)



        }
        else if(!$('.drawer.animate.active').length>0 && draweload==true){
          draweload=false;
          console.log("no")
            $('.aco-box.animate__none').show()

        }
        },500)


  // =============================== Upsel Products =========================


$(document).ready(function(){

    var isLoaded211=false;
      var _intv = setInterval(function(){
        if($('.drawer.animate.active').length>0 && isLoaded211==false){
          isLoaded211=true;
          // console.log("open")
          //   $('.drawer__inner .popxx').remove()
          
          // setTimeout(function(){  
          //     $('[href="/products/mystery-gift"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx" style="display: flex;"> <span class="popup" onclick="myFunction()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF WINERS PAKKET, MYSTERY PRIZE</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p> Bij Elke Competitie Hoort Een Winaar, En Een Winnaar Verdient Natuurlijk Een Prijs! Deze Mystery Gift Met Twee Toffe Prijzen Maakt De Strijd Nog Spannender. Het Is De Ultieme Beloning Voor Jouw Overwinning. Wat Erin Zit? Dat Blijft Een Verrassing… Tot Je Wint!</p> </span> </span> </div>')
          //     $('[href="/products/visor"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx BLAUW" style="display: flexxxxx;"> <span class="popup BLAUW" onclick="myFunctionBLAUW()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup BLAUW"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP BLAUW</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
          //     $('[href="/products/geel"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx GEEL" style="display: flexxxxx;"> <span class="popup GEEL" onclick="myFunctionGEEL()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup GEEL"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP GEEL</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
          //     $('[href="/products/groen"]').parents('[data-essential-upsell-element="content-container"]').after('<div class="boxx GROEN" style="display: flexxxxx;"> <span class="popup GROEN" onclick="myFunctionGROEN()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup GROEN"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP GROEN</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
          //     $('[href="/products/paars"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx PAARS" style="display: flexxxxx;"> <span class="popup PAARS" onclick="myFunctionPAARS()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup PAARS"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP PAARS</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
          //     $('[href="/products/rood"]').parents('[data-essential-upsell-element="content"]').after('<div class="boxx ROOD" style="display: flexxxxx;"> <span class="popup ROOD" onclick="myFunctionROOD()"><span class="popxx mblxx" style="margin-left: -15px;"> i<span><span class="popuptext" id="myPopup ROOD"><div style=" display: inline-flex; width: 100%; "><span class="headx" style=" width: 100%; border-bottom:1px solid silver; font-size: x-large; ">PUBGOLF TEAM ZONNEKLEP ROOD</span><span style="text-align: right; font-size:large; font-weight: bold; ">X</span></div>  <p>MET DEZE KLEURRIJKE PUBGOLF ZONNEKLEPPEN WEET IEDEREEN METEEN BIJ WELK TEAM JIJ HOORT. IDEAAL VOOR WAT GEZONDE RIVALITEIT EN OM JE PUBGOLF LOOK COMPLEET TE MAKEN. KIES JE KLEUR, VORM EEN TEAM, EN LAAT ZIEN WIE HET BESTE TEAM HEEFT.</p> </span> </span> </div>')
          // },1500)

        }
        else if(!$('.drawer.animate.active').length>0 && isLoaded211==true){
          isLoaded211=false;
          // console.log("close")
        }
        },500);
  
     setTimeout(function(){  
      // $('cart-items [data-essential-upsell-element="title"],cart-items [data-essential-upsell-element="image-container"]').removeAttr('href')
    },3000)

})


// ================= Popup =====================


// When the user clicks on div, open the popup
function myFunction() {
  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
}

function myFunctionBLAUW() {
  var popup = document.getElementById("myPopup BLAUW");
  popup.classList.toggle("show");
}

function myFunctionGEEL() {
  var popup = document.getElementById("myPopup GEEL");
  popup.classList.toggle("show");
}
  
function myFunctionGROEN() {
  var popup = document.getElementById("myPopup GROEN");
  popup.classList.toggle("show");
}
  
function myFunctionPAARS() {
  var popup = document.getElementById("myPopup PAARS");
  popup.classList.toggle("show");
}

function myFunctionROOD() {
  var popup = document.getElementById("myPopup ROOD");
  popup.classList.toggle("show");
}




